import { ROUTE_PATHS } from "@bcc/lib/constants";
import { cn } from "@bcc/lib/utils";
import { generateTestId } from "@client-shared";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const LINKS = [
  { id: "roasters", to: ROUTE_PATHS.ADMIN_ROASTERS, labelKey: "admin.productCatalogue.nav.roasters" },
  { id: "products", to: ROUTE_PATHS.ADMIN_PRODUCTS, labelKey: "admin.productCatalogue.nav.products" },
] as const;

export const setAdminNavTestId = (identifier: string): string => generateTestId("AdminNav", identifier);

/**
 * Roasters ↔ Products toggle for the admin pages. Plain router links only: the
 * admin impersonation lives in localStorage and navigation must never clear it.
 */
export function AdminNav() {
  const { t } = useTranslation();

  return (
    <nav
      aria-label={t("admin.productCatalogue.nav.label")}
      className="flex gap-1 rounded-lg bg-muted p-1"
      data-testid={setAdminNavTestId("container")}
    >
      {LINKS.map((link) => (
        <NavLink
          key={link.id}
          to={link.to}
          data-testid={setAdminNavTestId(link.id)}
          className={({ isActive }) =>
            cn(
              "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
              isActive ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"
            )
          }
        >
          {t(link.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
}
